import { type FunctionComponent, type PropsWithChildren } from 'react';
import { HelpIcon } from '../help-icon/help-icon.component';

export type LabelProps = {
	label: string;
	required?: boolean;
	className?: string;
	id?: string;
	helpTextTooltip?: React.ReactElement | string;
	// internalOnlyHelpTooltip: Pass true if the tooltip should only show for internal users and should have internal styling
	internalHelpTooltip?: boolean;
	popoverClassName?: string;
	boldLabel?: boolean; // TODO: EFDC-37817 - remove once theme-luxury is finalized, font-medium is used for all labels
};

export const Label: FunctionComponent<PropsWithChildren<LabelProps>> = ({
	children,
	label,
	helpTextTooltip,
	internalHelpTooltip,
	popoverClassName,
	required,
	className = '',
	id
}) => {
	return (
		<label className={`border-box db w-100 ${className}`} htmlFor={id}>
			<div className="flex items-center mb-1 theme-luxury:mb-1.5!">
				<div className={`${helpTextTooltip ? 'f6 mr1 theme-luxury:mr-0.5!' : 'f6'} `}>
					<span className={`font-medium theme-luxury:text-secondary!`}>{label}</span>
					{required && (
						<span className="theme-error ml1 theme-luxury:text-teal-500! theme-luxury:ml-0.5! theme-luxury:font-medium!">
							*
						</span>
					)}
				</div>
				{helpTextTooltip && (
					<div className="f6 mt1">
						<HelpIcon
							className={popoverClassName}
							iconClassName={`${
								internalHelpTooltip ? 'theme-internal' : 'theme-primary theme-luxury:fg-quaternary!'
							} f6 theme-luxury:text-base!`}>
							<div>{helpTextTooltip}</div>
						</HelpIcon>
					</div>
				)}
			</div>
			{children}
		</label>
	);
};

export type MaybeLabelProps = { label?: string } & Omit<LabelProps, 'label'>;

export const MaybeLabel: FunctionComponent<PropsWithChildren<MaybeLabelProps>> = ({ label, ...remainingProps }) => {
	return label ? (
		<Label label={label} {...remainingProps}>
			{remainingProps.children}
		</Label>
	) : (
		<>{remainingProps.children}</>
	);
};
